//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheTinyInput",
  props: {
    value: {
      type: [Number, String],
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: 'text'
    },
    size: {
      type: String,
      default: "small"
    }
  },
  methods: {
    updateValue(newValue) {
      let emitValue = newValue.toString()
      this.$emit('input', emitValue);
    },
  }
}
